export const UserRoles = Object.freeze({
  CLIENT: 'Client',
  PROVIDER_APPLICANT: 'ProviderApplicant',
  PROVIDER_BASIC: 'ProviderBasic',
  PROVIDER_PRO: 'ProviderPro',
  PROVIDER_WITHOUT_SUBSCRIPTION: 'ProviderWithoutSubscription',
});
